export default function validAcessRoute(typeRoles, userProfiles) {
    let i = 0
    
    if (userProfiles.adm_roles) {
        userProfiles.adm_roles.forEach(item => {
            if (typeRoles.includes(item.name)) {
                i++
            }
        })
    }
    return i;

}